import PriceBookItemCard from "@molecules/ObjectCard/ObjectCards/PriceBookItemCard/PriceBookItemCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function PricebookCardsView() {
    return (
        <CardsView.List<PricebookItem>>
            {(pricebookItem, displayedAttributes) => (
                <PriceBookItemCard pricebookItem={pricebookItem} displayedAttributes={displayedAttributes} />
            )}
        </CardsView.List>
    )
}
